import { createQueryKeys } from '@wiggot/libs/react-query'

export const METRICS_KEYS = createQueryKeys('metricsService', {
  getCapitalGains: (lat: number, lng: number) => [lat, lng]
})
